// app/javascript/controllers/form_submit_loader_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton", "overlay"]

  connect() {
    this.form = this.element
    this.form.addEventListener("submit", this.showLoader.bind(this))

    // direct_upload events (ActiveStorage)
    this.form.addEventListener("direct-upload:start", this.showLoader.bind(this))
    this.form.addEventListener("direct-upload:end", this.hideLoader.bind(this))
    // Если несколько файлов — overlay снимается только после всех direct-upload:end и submit
    this._activeUploads = 0
    this.form.addEventListener("direct-upload:initialize", (e) => {
      this._activeUploads++
    })
    this.form.addEventListener("direct-upload:end", (e) => {
      this._activeUploads--
      if (this._activeUploads <= 0) {
        this.hideLoader()
      }
    })

  }

  showLoader(event) {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
    }
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("d-none")
    }
  }

  hideLoader() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = false
    }
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add("d-none")
    }
  }
}
